import { render, staticRenderFns } from "./file-picker.vue?vue&type=template&id=1851ecae&"
import script from "./file-picker.vue?vue&type=script&lang=js&"
export * from "./file-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1851ecae')) {
      api.createRecord('1851ecae', component.options)
    } else {
      api.reload('1851ecae', component.options)
    }
    module.hot.accept("./file-picker.vue?vue&type=template&id=1851ecae&", function () {
      api.rerender('1851ecae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/file-picker/file-picker.vue"
export default component.exports